import * as React from "react";
import { ShieldCheck, PhoneCall } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function InsuranceClaimBanner() {
  return <section id="insuranceclaimbanner" className="w-full bg-primary text-primary-foreground py-16 md:py-20 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_top_right,_var(--color-secondary)_0%,_transparent_40%)] pointer-events-none" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-16">
          
          <div className="flex-1 space-y-6 text-center lg:text-left">
            <Badge variant="secondary" className="px-4 py-1.5 text-sm font-bold uppercase tracking-wider shadow-sm">
              <ShieldCheck className="w-4 h-4 mr-2" />
              Insurance Advisement
            </Badge>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default leading-tight">
              We Work Directly With Your Insurance Company
            </h2>
            
            <p className="text-primary-100 text-lg md:text-xl max-w-2xl mx-auto lg:mx-0 font-sans">Hit by storm damage? Don't stress. Eagle Exteriors We guide you through the entire claim process, acting as your advocate to ensure you receive the full coverage your home deserves. from storm and roof damage quickly. We the entire claim process, ensuring your roof gets the repair or replacement it needs without the hassle.</p>
            <p className="text-secondary font-bold text-lg">Help you meet insurance deadlines confidently.</p>
          </div>

          <div className="flex-shrink-0 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <Button asChild size="lg" variant="secondary" className="font-bold text-base h-14 px-8 shadow-lg hover:shadow-xl transition-shadow">
              <Link to="/StormDamageRepairPage">
                Start Your Free Storm Assessment
              </Link>
            </Button>
            
            <Button asChild size="lg" variant="outline" className="font-bold text-base h-14 px-8 bg-transparent border-2 border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary transition-colors">
              <Link to="/ContactPage"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone-call w-5 h-5 mr-2" aria-hidden="true"><path d="M13 2a9 9 0 0 1 9 9"></path><path d="M13 6a5 5 0 0 1 5 5"></path><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>Call Today</Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}